module.exports = "/static/images/travel-guide-2017.png";